import "./Profile.css"
import React from 'react'
import { observer } from "mobx-react"

import UIRect from "./UIRect"
import Window from "./Window"
import X from "./X"

export class Profile extends React.Component {

  render() {
    const { profile } = this.props
    return (
      <Window 
        className="Profile"
        borderColor={profile.color}
        width={180} 
        height={60} 
        cornerWidth={20}>
        <h1 style={{color: profile.color}}>{ profile.name } ({profile.mbti})</h1>
        <h2>{ profile.funcs.join(",") }</h2>
        <div className="Profile__close" >
          <X onClick={this.props.onRemove} />
        </div>
      </Window>     

    )
  }
}

export default observer(Profile)


// WEBPACK FOOTER //
// ./src/components/Profile.js